import React, { Component } from "react";
import firebase from "../Firebase/Firebase";
import Formatter from "../Formatters/Formatters";
import "./Pse.css";

class FulfillRequest extends Component {
  constructor() {
    super();

    this.state = {
      id: "",
      name: "",
      phoneNumber: "",
      amount: 0,
      description: ""
    };
  }

  componentDidMount() {
    const id = this.props.match.params.id;

    this.setState({ id });

    return firebase
      .database()
      .ref("/requests/" + id)
      .once("value")
      .then(snapshot => {
        const request = snapshot.val();

        this.setState({ ...request });
      });
  }

  render() {
    const { amount, description, name, phoneNumber } = this.state;

    return (
      <div className="pse">
        <h1 className="pse-title">Banka</h1>
        <dl className="pse-details-list">
          <dt className="pse-details-item-term">Monto</dt>
          <dd className="pse-details-item-data">
            COP {Formatter.numberToPrice(amount, { showDecimals: false })}
          </dd>
          <dt className="pse-details-item-term">Transferir a</dt>
          <dd className="pse-details-item-data">
            <div>{name}</div>
            <div>{phoneNumber}</div>
          </dd>
          <dt className="pse-details-item-term">Descripción</dt>
          <dd className="pse-details-item-data">{description}</dd>
        </dl>
        <p>Ingrese sus detalles de Banka para completar la transferencia</p>
        <form action="">
          <div className="pse-input-group">
            <label className="pse-label">Nombre de usuario</label>
            <input
              className="pse-input"
              id="username"
              name="username"
              type="text"
            />
          </div>
          <div className="pse-input-group">
            <label className="pse-label">Contraseña</label>
            <input
              className="pse-input"
              id="password"
              name="password"
              type="password"
            />
          </div>
          <button className="pse-submit button-green">
            Transferir con Banka
          </button>
        </form>
      </div>
    );
  }
}

export default FulfillRequest;



// WEBPACK FOOTER //
// ./src/Pse/Pse.js